"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ThreejsData_obj;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreejsData = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
class ThreejsData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(obj, id) {
        super(id);
        // #region Properties (1)
        _ThreejsData_obj.set(this, void 0);
        __classPrivateFieldSet(this, _ThreejsData_obj, obj, "f");
    }
    // #endregion Constructors (1)
    // #region Public Accessors (2)
    get obj() {
        return __classPrivateFieldGet(this, _ThreejsData_obj, "f");
    }
    set obj(value) {
        __classPrivateFieldSet(this, _ThreejsData_obj, value, "f");
    }
    // #endregion Public Accessors (2)
    // #region Public Methods (1)
    clone() {
        return new ThreejsData(this.obj, this.id);
    }
}
exports.ThreejsData = ThreejsData;
_ThreejsData_obj = new WeakMap();
//# sourceMappingURL=ThreejsData.js.map